// Shared category-inference for user templates. Both /savedtemplates and the
// in-editor preview strip want to bucket a template by what kind of email it
// is — Welcome / Newsletter / Launch / Event / Promo / Transactional /
// Feedback / Re-engagement / Seasonal / Thanks / Other — without writing
// anything back to Mongo. Order matters: more specific rules first.

const CATEGORY_RULES = [
	{tag: 'Welcome',       patterns: ['welcome', "you're all set", 'you are all set']},
	{tag: 'Newsletter',    patterns: ['newsletter', 'this week', 'weekly']},
	{tag: 'Launch',        patterns: ['launch', 'introducing', 'new ']},
	{tag: 'Event',         patterns: ['invited', 'invite', 'rsvp', 'office hours']},
	{tag: 'Promo',         patterns: ['% off', ' off', 'sale', 'discount', 'deal', 'promo']},
	{tag: 'Transactional', patterns: ['receipt', 'invoice', 'order', 'confirmation', 'subscription']},
	{tag: 'Feedback',      patterns: ['feedback', 'survey', 'rating', 'favor', 'how was']},
	{tag: 'Re-engagement', patterns: ['miss you', 'come back', 'still there']},
	{tag: 'Seasonal',      patterns: ['holiday', 'happy', 'season', 'thanks for the year']},
	{tag: 'Thanks',        patterns: ['thank you', 'thank-you', 'appreciate']},
];

export function inferCategory(subject, content) {
	const haystack = ((subject || '') + ' ' + (content || '')).toLowerCase();
	for (const {tag, patterns} of CATEGORY_RULES) {
		if (patterns.some((p) => haystack.includes(p))) return tag;
	}
	return 'Other';
}

// Return the categories to show for a template — prefer user-set
// `selectedCategories` (if any), else infer one from the subject + content.
// Never mutates input. Always returns at least one entry.
export function ensureCategories(template) {
	const userCats = Array.isArray(template && template.selectedCategories)
		? template.selectedCategories.filter(Boolean)
		: [];
	if (userCats.length > 0) return userCats;
	return [inferCategory(template && template.subject, template && template.content)];
}
